document.addEventListener("DOMContentLoaded", (event) => {
    const collectionList = document.querySelectorAll('.catalogue-grid');
    collectionList.forEach(function (catalogueGrid) {
        catalogueGrid.addEventListener('click', async function (event) {
            event.preventDefault();
            if (!this.classList.contains('active')) {
                collectionList.forEach(link => {
                    link.classList.remove('active', 'border-[#4C148A]');
                    link.classList.add('border-[#FDE1FF]');
                });
                this.classList.remove('border-[#FDE1FF]');
                this.classList.add('active','border-[#4C148A]');
                const catalogueUrl = this.getAttribute('data-url');
                history.pushState({}, "", catalogueUrl);
    
                // Remove scrolling feature
                // const mainCollectionGrid = document.querySelector('.yummuy_main_collection__grid');
                // const offset = 100;
                // const elementPosition = mainCollectionGrid.getBoundingClientRect().top + window.scrollY;
                // const offsetPosition = elementPosition - offset;
    
                // window.scrollTo({
                //     top: offsetPosition,
                //     behavior: 'smooth'
                // });
    
                // Add loading animation
                const mainCollectionGrid = document.querySelector('.yummuy_main_collection__grid');
                const overlay = document.createElement('div');
                overlay.className = 'overlay-new';
                overlay.innerHTML = `
                    <div class="loading-animation-2"></div>
                `;
                mainCollectionGrid.style.position = 'relative'; // Ensure the parent is positioned
                mainCollectionGrid.appendChild(overlay);
    
                try {
                    const response = await fetch(`${catalogueUrl}?sections=yummuy_ajax_collection`);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
    
                    const data = await response.json();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data["yummuy_ajax_collection"], "text/html");
                    const collectionGrid = doc.querySelector(".yummuy_main_collection");
    
                    if (collectionGrid) {
                        const mainCollectionGrid = document.querySelector('.yummuy_main_collection');
                        if (mainCollectionGrid) {
                            
                            // Set initial opacity to 0
                            mainCollectionGrid.style.opacity = 0;
                            mainCollectionGrid.innerHTML = ''; // Clear existing content
                            mainCollectionGrid.appendChild(collectionGrid);
    
    
                            // Function to gradually increase opacity
                            const fadeIn = (element, duration) => {
                                let opacity = 0;
                                const increment = 16 / duration; // Assuming 60fps, 16ms per frame
    
                                const animate = () => {
                                    opacity += increment;
                                    if (opacity <= 1) {
                                        element.style.opacity = opacity;
                                        requestAnimationFrame(animate);
                                    } else {
                                        element.style.opacity = 1; // Ensure final opacity is 1
                                    }
                                };
    
                                animate();
                            };
    
                            // Start fade-in animation
                            fadeIn(mainCollectionGrid, 300); // 300ms duration
    
                            attachTagClickListener();
                        } else {
                            console.error('section element not found in the DOM.');
                        }
                    } else {
                        console.error('Collection grid not found in the fetched data.');
                    }
                } catch (error) {
                    console.error('Error fetching collection data:', error);
                    // Show error message in place of loading animation
                    mainCollectionGrid.innerHTML = '<div class="error-message">Failed to load content. Please try again.</div>';
                } finally {
                    // Animate the overlay opacity to 0
                    overlay.classList.add('hidden-opacity');
                    // Remove the overlay after the transition
                    setTimeout(() => {
                        mainCollectionGrid.removeChild(overlay);
                    }, 30000); // Match the duration with the CSS transition duration
                }
            }
        });
    });
    function attachTagClickListener() {
        const tagList = document.querySelectorAll('.collection_tag_list');
        if (tagList.length) {
            tagList.forEach(tag => {
                tag.addEventListener('click', async (event) => {
                    event.preventDefault();
                    tagList.forEach(link => link.classList.remove('active'));
                    tag.classList.add('active');
                    const tagUrl = event.currentTarget.getAttribute('data-url');
                    try {
                        const response = await fetch(`${tagUrl}?sections=yummuy_ajax_collection`);
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        const data = await response.json();
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data["yummuy_ajax_collection"], "text/html");
                        const collectionGrid = doc.querySelector(".yummuy_main_collection__grid");
    
                        if (collectionGrid) {
                            const mainCollectionSection = document.querySelector('.yummuy_main_collection__grid');
                            mainCollectionSection.innerHTML = '<div class="loading-animation">Loading...</div>';
    
                            if (collectionGrid) {
                                const mainCollectionSection = document.querySelector('.yummuy_main_collection__grid');
                                if (mainCollectionSection) {
                                    mainCollectionSection.innerHTML = collectionGrid.innerHTML;                               
                                } else {
                                    console.error('Main collection section not found in the DOM');
                                }
                            } else {
                                console.error('Collection grid not found in the response');
                            }
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                        // Show error message in place of loading animation
                        mainCollectionSection.innerHTML = '<div class="error-message">Failed to load content. Please try again.</div>';
                    }
                });
            });
        } else {
            console.error('No tags found to attach listeners.');
        }
        setTimeout(function() {
            $('.ruk-rating-snippet-count b').each(function() {
              var number = parseFloat($(this).html()),
                  rounded = number.toFixed(1);
              $(this).html(rounded);
            });
          },2000);
    }
    attachTagClickListener();
    });